import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/subclinical-subject";

export const pagingSubclinicalSubject = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getSubclinicalSubjectById = (subclinicalSubjectId) => axios.get(API_PATH + "/getbyid/" + subclinicalSubjectId);

export const saveSubclinicalSubject = subclinicalSubject => axios.post(API_PATH + "/save-or-update", subclinicalSubject);

export const deleteSubclinicalSubject = subclinicalSubjectId => axios.delete(API_PATH + '/mark-delete/' + subclinicalSubjectId);
